// Create Batch Message Template
export const CREATE_BATCH_MESSAGE_TEMPLATE_REQUEST = 'CREATE_BATCH_MESSAGE_TEMPLATE_REQUEST';
export const CREATE_BATCH_MESSAGE_TEMPLATE_DONE = 'CREATE_BATCH_MESSAGE_TEMPLATE_DONE';
export const CREATE_BATCH_MESSAGE_TEMPLATE_FAILED = 'CREATE_BATCH_MESSAGE_TEMPLATE_FAILED';
export const CREATE_BATCH_MESSAGE_TEMPLATE_RESET = 'CREATE_BATCH_MESSAGE_TEMPLATE_RESET';